import {TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE} from '../shared/abstract-boxes';

export function SurveyFeedbackBoxViewConstructor(services, callbacks, context, siteTypeConfig) {
  
  let joint = services.joint;

  return joint.shapes.html.AbstractBoxElementView.extend({

    isElementEditable: true,
    editElementModalController: 'editSurveyFeedbackBoxController',
    editElementModalTemplate: require('./editSurveyFeedbackBox.modal.html'),

    angularTemplate: `
<div layout="column">
  <span>{{ elementData.message.text }}</span>
  <attachment-thumbnail ng-repeat="attachment in elementData.message.attachments" 
                        attachment="attachment"
                        on-img-load="elementView.resizeBox()"
                        company-id="context.companyId"></attachment-thumbnail>
</div>
`,


    afterEditElement: function() {
      this.updateEmbeddedAnswers();
    },

    /**
     * Updates embeded AnswerViews from the current model.
     * Will try to match existing answers using their id
     * (it is up the edition dialog to keep existing answer ids as much as possible)
     */
    updateEmbeddedAnswers: function() {
      const newAnswersData = this.angularScope.elementData.answers;
      let box = this.model;
      let currentAnswers = box.getEmbeddedCells();
      currentAnswers.forEach(answer => {
        if (answer.get('type') !== 'html.UserInput'){
          box.unembed(answer);
        }
      });
      newAnswersData.forEach(newAnswerData => {
        const matchingCurrentAnswer = currentAnswers.find(answer => answer.id === newAnswerData.id);
        if (matchingCurrentAnswer) {
          // If we found an existing answer with the same id, let's reuse it, so that we don't loose its link, if any
          matchingCurrentAnswer.get('elementData').label = newAnswerData.label;
          matchingCurrentAnswer.get('elementData').score = newAnswerData.score; // probably didn't change but assign it anyway
          box.embed(matchingCurrentAnswer);
        } else {
          // Let's create a new Answer if the modal decided we need a new one
          const answerElementData = {
            'label': newAnswerData.label,
            'score': newAnswerData.score
          }
          const newAnswer = this.createAnswer(newAnswerData.id, TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE, answerElementData); // the modal is responsible for fetching new unique ids from the database
          box.graph.addCell(newAnswer);
          box.embed(newAnswer);
        }
      });
      // remove any existing answer (except userInput) whose id wasn't present in the new answers data
      currentAnswers.forEach(answer => {
        if (!answer.isEmbeddedIn(box)) {
          answer.remove();
        }
      });
    },

    //Create an answer element with given id
    createAnswer: function(id, position, size, elementData) {
      return new joint.shapes.html.SurveyFeedbackAnswer( { id, position, size, elementData } );
    },

  });
}
